import { render, staticRenderFns } from "./UpcomingCampaigns.vue?vue&type=template&id=b7434b24&scoped=true"
import script from "./UpcomingCampaigns.vue?vue&type=script&lang=ts"
export * from "./UpcomingCampaigns.vue?vue&type=script&lang=ts"
import style0 from "./UpcomingCampaigns.vue?vue&type=style&index=0&id=b7434b24&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7434b24",
  null
  
)

export default component.exports